import { useEffect } from 'react'
import {
    AdvancedMarker,
    Map as GoogleMap,
    useMap,
} from '@vis.gl/react-google-maps'

import { getMapMarkerIcon } from './mapMarkers'
import {
    MAP_ID,
    MAX_ZOOM,
} from '../../maps/constants'

interface DetailDevice {
    oilLevelPercentage?: number
    oilAlarm?: boolean
    isMonitored?: boolean
    marker: {
        lat: number
        lng: number
    }
}

interface DetailGoogleMapProps {
    device: DetailDevice
}

const DETAIL_ZOOM = 13
const DEFAULT_DETAIL_CENTER: google.maps.LatLngLiteral = {
    lat: 49.8037633,
    lng: 15.4749126,
}

const FitToMarker = ({ position }: { position: google.maps.LatLngLiteral }) => {
    const map = useMap()
    const { lat, lng } = position

    useEffect(() => {
        if (!map) {
            return
        }

        const bounds = new google.maps.LatLngBounds()
        bounds.extend({ lat, lng })
        map.fitBounds(bounds)
        // single-marker fit zooms in too far; restore to detail zoom
        map.setZoom(DETAIL_ZOOM)
    }, [map, lat, lng])

    return null
}

const DetailGoogleMap = ({ device }: DetailGoogleMapProps) => {
    const iconUrl = getMapMarkerIcon(
        device.oilLevelPercentage,
        device.isMonitored,
        device.oilAlarm,
    )

    const position: google.maps.LatLngLiteral = {
        lat: device.marker.lat,
        lng: device.marker.lng,
    }

    return (
        <GoogleMap
            mapId={MAP_ID}
            defaultCenter={DEFAULT_DETAIL_CENTER}
            defaultZoom={DETAIL_ZOOM}
            maxZoom={MAX_ZOOM}
            className="bg-white map"
            style={{ width: '100%', height: 300 }}
        >
            <AdvancedMarker position={position}>
                <img src={iconUrl} alt="" width={45} height={45} />
            </AdvancedMarker>
            <FitToMarker position={position} />
        </GoogleMap>
    )
}

export default DetailGoogleMap
